
export default {
  props: {
    navItems: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      isOpened: false,
    }
  },
  mounted() {
    this.$watch('$refs.menu.isActive', (newVal) => {
      this.isOpened = newVal
      // this.$store.commit('setNavOpened', newVal)
    })
  },
  methods: {
    show(state) {
      this.$refs.menu.show(state)
    },
  },
}
